import types from './types';

export const updateAuthUserPassword = () => ({
    type: types.UPDATE_AUTH_USER_PASSWORD,
});
